module.exports = __webpack_public_path__ + "static/pic01-6f7f898adca301e7579175889948d8fd.jpg";